import React from 'react'
import Stage11 from '../../images/Stage1-1.svg'
import Stage12 from '../../images/Stage1-2.svg'
import Stage13 from '../../images/Stage1-3.svg'

import Stage21 from '../../images/Stage2-1.svg'
const Stage22 = 'https://djhonz7dexnot.cloudfront.net/062585d01838e7fb68153dbb323f25c8677e12bf.png';
const Stage23 = 'https://djhonz7dexnot.cloudfront.net/bec8879b8e812fa7e51a59fcc16ddcd05dcda2b3.png';

const rahasyamay_prem = {
  template : 1,
  storyPoints: [
    {
      key: 1,
      point:
        'सबसे अहम मुद्दा - उपन्यास के हर chapter के अंत में दिलचस्प सवाल या किसी रोमांस रहस्यमय प्रेम का scene के साथ हो जिससे पाठकों की रूचि बनी रहे.',
    },
    {
      key: 2,
      point:
        'Narration past में हो इस बात का ध्यान रखें! और narration ज़्यादा से ज़्यादा 100 शब्दों का हो ।',
    },
    {
        key: 3,
        point:
          'Dialogue narrative format में हो, ना की dramatic format में जैसे की, केशव - "" दीदी! मैं आपका पीछा कभी नहीं छोड़ने वाला, आप जहाँ ....""',
    },
    {
        key: 4,
        point:
         <> उपन्यास में दो conflict ( संघर्ष ) होने चाहिए 
         <br/> a.एक मुख्य संघर्ष - जिसपे आपकी उपन्यास का पूरा a plot निर्भर हो ! 
         <br/> b.दूसरा उप संघर्ष - जिससे कहानी में रोमांच बरकरार रहे, और आपकी उपन्यास का emotional graph (भावनिक उतार- चढ़ाव) सही तरीके से प्रदर्शित होता रहे </>,
    },{
        key: 5,
        point:
          'उपन्यास लिखते वक़्त punctuation का ध्यान रखें',
    },
  ],
  StageContent: [
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'stage 1 ',
      stageSubHeading: 'Stage 1 starts from 2nd Jun',
      tableContent: [
        {
          title: 'Last Date to complete 20k words',
          img: '⌛',
          date: '26th Jun',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '8th Jul',
        },
      ],
      stageContent: (
        <>
          सभी लेखको को अपनी उपन्यास के 20,000 शब्द दिए गए अवधी से पहले पूरे करने
          होंगे। तभी आप स्टेज 1 के पात्र होंगे।
          <br />
          1.आपकी उपन्यास रहस्यमय की शैली में होनी चाहिए
          <br />
          2. Top 5 लेखक होगें हकदार हमारे इस आकर्षक इनाम के
          <br />
          3. प्रत्येक लेखक केवल एक पुरस्कार के लिए पात्र है
        </>
      ),
      firstPrize: Stage11,
      secondPrize: Stage12,
      thirdPrize: Stage13,
      rank4And5Prize: '₹750/-',
      isLive: true,
    },
    {
      bgColor: '#F2F2F2',
      headingbgColor: '#DCDCDA',
      stageheading: 'stage 2 ',
      stageSubHeading: 'Stage 2 में बरक़रार रहने के लिए उपन्यास लिखते रहें।',
      tableContent: [
        {
          title: 'The last date to complete 50,000 words ',
          img: '⌛',
          date: '16th Jul',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: '30th Jul',
        },
      ],
      stageContent: (
        <>
          सभी लेखको को अपनी उपन्यास के 50,000 शब्द दिए गए अवधी से पहले पूरे करने
          होंगे। तभी आप स्टेज 2 के पात्र होंगे।
          <br />
          1. अपनी उपन्यास के 30,000 शब्द पूरे करने के बाद अगर आपकी कहानी रीडर्स द्वारा सबसे ज्यादा पसंद की जाती है तो वो उपन्यास हमारे Writer Benefit Program के लिए भी चुनी जाएगी।
          <br /> 2. Top 10 लेखक होगें हकदार हमारे इस आकर्षक इनाम के।
          <br /> 3. विजेताओं को सर्टिफिकेट से सम्मानित किया जाएगा।"
        </>
      ),
      firstPrize: Stage21,
      secondPrize: Stage22,
      thirdPrize: Stage23,
      lowerRankCombinedPrizeTitle: <>Rank 4th to 10th </>,  
      rank4And5Prize: '₹1000/-',
      isLive: true,
    },
  ],
  exampleNovels: [
    {
      title: 'Vampire|वैम्पायर',
      novelImgLink:
        'http://djhonz7dexnot.cloudfront.net/87101644598686cb7eaedbdf2da7a9f7e7fcadc5.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/7e7599758ea1300b156a54f05ae59dc6c95e08e6',

      novelId : '7e7599758ea1300b156a54f05ae59dc6c95e08e6'
    },
    {
      title: 'Dark Night with Dark Shadow | डार्क नाइट विद डार्क शैडो',
      novelImgLink:
        'http://djhonz7dexnot.cloudfront.net/e3dc6455ecafdb9370379bba2346aff9fccd765f.webp',
      novelLink:
        'https://www.pocketnovel.com/novel/0751428826551095b1a1006fdc735995c741f5ac',
      novelId: '0751428826551095b1a1006fdc735995c741f5ac'
    },
  ],
  FAQs: [
    {
      question: 'How to enter a book into the contest ?',
      answer:
        'For books created after contest start date, Go to the book & click on "Edit Novel " & select the contest & Save Changes',
    },
    {
      question: 'When will the awards be given to the author ?',
      answer:
        'The awards will be sent within thirty days after the results are announced',
    },
  ],
  constants: {
    heading: 'Rahasyamay Prem कहानियों का सिलसिला',
    subHeading: 'कलम की ताकत के साथ जीते नगद इनाम',
    bannerButton: 'JOIN THE CONTEST & WRITE',
    section_1_Heading: (
      <>
        प्रतियोगिता स्वरुप <span role="img"> 🏁 </span> ये प्रतियोगिता दो भागों
        में आयोजित की जाएगी{' '}
      </>
    ),
    prizeSubheading:
      'First prize will have the opportunity to possibly become an audio book with revenue share',
    stageButton: 'Enter Contest',
    section_2_Heading: 'Receive Certificate for your Literary Excellence',
    section_3_Heading: 'उदाहरण के लिए हमारी कुछ Rahasyamay Prem Novels',
    novelContent: 'Read now',
    section_4_Heading: 'उपन्यास लिखने के 5 आसान तरीके',
    earnHeading: <>Earn Upto 10 Lakh <br/> Per Year</>,
    earnSubheading: (
      <>
        After completion of 30K words you can enter into <br />
        Writer’s Benefit Program
      </>
    ),
    earnSectionButton: 'Learn more about the program ',
    section_5_Heading: 'Frequently Asked Questions ⁉️',
    contestId: 'bcef3697e35ae3cadde6c40791828cc49fa6c74d',
    defaultReferrer: 'contest_rahasyamay_prem',
    visibility: 'india',
  },
  participation_certificate_image: 'https://djhonz7dexnot.cloudfront.net/827906bac4aed3a5ad4ee81eb03d27cb63982c2f.png',

  WinnersStage1: [
    {
      position : 1.1,
      AuthorName : "Smiling Star",
      NovelTitle : "Rebirth Of The Devil's Angel",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/2e8af654fd0314715f1b92f31560eb6a1834062b.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/a80a063343b18e2dc298fd05e2316d3dc04ebf0b",
      id: "a80a063343b18e2dc298fd05e2316d3dc04ebf0b",
      Reward : "₹7500"
    },
    {
      position : 1.2,
      AuthorName : "Early bird",
      NovelTitle : "My Vampire: A Protector",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/758522acce20143e15d8771ebfa7b7438c24a6d6.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/60096e74b7bfab6d6ff6c5bce8507977cb011806",
      id: "60096e74b7bfab6d6ff6c5bce8507977cb011806",
      Reward : "₹4500"
    },
    {
      position : 1.3,
      AuthorName : "Romantic Queen {Nisha}",
      NovelTitle : "My Possessive Vampire Hubby",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/3b83fc034612f26e62c1359ccb0ce2f5ac1b3555.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/df06bb90c55f6041f7278a920b72205fe981672a",
      id: "df06bb90c55f6041f7278a920b72205fe981672a",
      Reward : "₹1500"
    },
    {
      position : 1.4,
      AuthorName : "Shiwani",
      NovelTitle : "Thirst of Blood: A Mysterious Love Story",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/e38b4b6cf2c26843c72112a6763d2686fc4f0b21.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/b4df609c64ac94593f0dfd60f1a7cc20d947b02e",
      id: "b4df609c64ac94593f0dfd60f1a7cc20d947b02e",
      Reward : "₹750"
    },
    {
      position : 1.5,
      AuthorName : "Muskan kumari",
      NovelTitle : "The Devil's Love With Half Angel",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/e9696414ea02ee1837459f8a32e003c1199a6ec3.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/fdb91e5fca8635bc327d71a83f6912a3a06bffb9",
      id: "fdb91e5fca8635bc327d71a83f6912a3a06bffb9",
      Reward : "₹750"
    },
  ],

  WinnersStage2: [
    {
      position : 2.1,
      AuthorName : "Miss Cutie Pie",
      NovelTitle : "My Magical Wife",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/abee06f53dd35d2786cacdbbf98b73f8725b9e99.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/255bb93a7afe47a00efe583653df27bcc0ce2e7e",
      id: "255bb93a7afe47a00efe583653df27bcc0ce2e7e",
      Reward : "₹17,500"
    },
    {
      position : 2.2,
      AuthorName : "Aastha Verma",
      NovelTitle : "My Vampire Husband",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/2fb9e5db3317a34ab39be7000aad3359e6ee385b.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/2634ad1450282656bf0ee07e02c3cb5d92eb38c5",
      id: "2634ad1450282656bf0ee07e02c3cb5d92eb38c5",
      Reward : "₹7000"
    },
    {
      position : 2.3,
      AuthorName : "नायरा",
      NovelTitle : "Kaisa Ye Pyaar Hai",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/bb5da5587ebb4fe8551be1ed51cea09002058e9b.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/eaa437406bbbd1a0ec3dd085625443b6953de8fb",
      id: "eaa437406bbbd1a0ec3dd085625443b6953de8fb",
      Reward : "₹3000"
    },
    {
      position : 2.4,
      AuthorName : "Ruchita",
      NovelTitle : "Angel With Secret Vampire",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/955cd312a383528aa1d8f91459d04cc3e2d9c3f8.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/5637a3b0f845c939ffc5dba5be8c62aac662b071",
      id: "5637a3b0f845c939ffc5dba5be8c62aac662b071",
      Reward : "₹1000"
    },
    {
      position : 2.5,
      AuthorName : "Kajal",
      NovelTitle : "Ishq; Khel Zindagi Ka",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/af07778e9ec11e884f99c2c5f00c74855a2ee707.jpeg",
      NovelUrl : "https://pocketnovel.com/novel/3ca2cad47d736106acc8f5a50e77a920a6ab8d81",
      id: "3ca2cad47d736106acc8f5a50e77a920a6ab8d81",
      Reward : "₹1000"
    },
    {
      position : 2.6,
      AuthorName : "Tanubala Sahu",
      NovelTitle : "Mohabbat Ek Junoon",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/2536b0ca1c5b0bfc51d26f355c0e7898d43eb4ea.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/7c2d50b95dafb5a588d5295e4b802dbadc092ec4",
      id: "7c2d50b95dafb5a588d5295e4b802dbadc092ec4",
      Reward : "₹1000"
    },
    {
      position : 2.7,
      AuthorName : "Yashi Srivastava",
      NovelTitle : "Queen Of Night",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/c63fb7caf412d5415feb68c93ff7ac39b5aae69e.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/918527da4ee565cfe0fe8b9849b0bdb60c3530c9",
      id: "918527da4ee565cfe0fe8b9849b0bdb60c3530c9",
      Reward : "₹1000"
    },
    {
      position : 2.8,
      AuthorName : "Vineeta Singh",
      NovelTitle : "Roohani Ishq",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/d894ba623ee51f0356cb474d7e2db782512a549c.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/1ad4142d82eeaa4e2fdb8f6b9e1e553f1686282b",
      id: "1ad4142d82eeaa4e2fdb8f6b9e1e553f1686282b",
      Reward : "₹1000"
    },
    {
      position : 2.9,
      AuthorName : "Jyoti Singh",
      NovelTitle : "Yuvrani",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/0d763c9046ddb7b868a59a80a94587d2f4bb29fb.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/58d7c2a461ed3e649a2eb967e9767b790e9efb07",
      id: "58d7c2a461ed3e649a2eb967e9767b790e9efb07",
      Reward : "₹1000"
    },
    {
      position : 2.10,
      AuthorName : "Anmol",
      NovelTitle : "Rebirth Of Mysterious Girl",
      ImageUrl : "https://djhonz7dexnot.cloudfront.net/859de0edc2ee0eea2283c9eaf30829ac670950a0.jpeg",
      NovelUrl : "https://www.pocketnovel.com/novel/bfcae757c4e535e25576ee68422d1361771de583",
      id: "bfcae757c4e535e25576ee68422d1361771de583",
      Reward : "₹1000"
    },
  ]
}

export default rahasyamay_prem
